export default "__VITE_ASSET__COjzoo51__"